<template>
  <TableLayout :permissions="['business:seo:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="页面名称" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入页面名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="关键字" prop="keywords">
        <el-input v-model="searchForm.keywords" placeholder="请输入关键字" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="页面地址" prop="pageAddr">
        <el-input v-model="searchForm.pageAddr" placeholder="请输入页面地址" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:seo:create', 'business:seo:delete']">
        <li><el-button type="primary" @click="$refs.operaSeoWindow.open('新建网站SEO配置')" icon="el-icon-plus" v-permissions="['business:seo:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:seo:delete']">删除</el-button></li>
      </ul>
      <el-table
         :height="tableHeightNew"
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="页面名称" min-width="100px"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="100px"></el-table-column>
        <el-table-column prop="keywords" label="关键字" min-width="150px"></el-table-column>
        <el-table-column prop="author" label="作者信息" min-width="100px"></el-table-column>
        <el-table-column prop="pageAddr" label="页面地址" min-width="150px"></el-table-column>
        <el-table-column prop="remark" label="描述" min-width="100px"></el-table-column>
        <el-table-column prop="imgalt" label="图片alt" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="操作时间" min-width="150px"></el-table-column>
        <el-table-column prop="editorName" label="操作人" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:seo:update', 'business:seo:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaSeoWindow.open('编辑网站SEO配置', row)" icon="el-icon-edit" v-permissions="['business:seo:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:seo:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaSeoWindow ref="operaSeoWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaSeoWindow from '@/components/business/OperaSeoWindow'
export default {
  name: 'Seo',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaSeoWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        title: '',
        keywords: '',
        author: '',
        pageAddr: ''
      }
    }
  },
  created () {
    this.config({
      module: '网站SEO配置',
      api: '/business/seo',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
